<template>
    <div>
        <div>
            <v-text-field label="Search..."
                          prepend-icon="mdi-magnify"
                          v-model="searchTerm"
                          density="compact"
                          clearable></v-text-field>
        </div>
        <v-data-table-server v-model:items-per-page="itemsPerPage"
                             v-if="typeof(totalItems) != undefined"
                             :headers="tableHeaders"
                             :items-length="totalItems"
                             :items="tableItems"
                             :loading="tableLoading"
                             :disable-pagination="removePaging"
                             :hide-default-footer="removePaging"
                             :hide-actions="removePaging"
                             density="compact"
                             @update:itemsPerPage="itemsPerPageChange"
                             @update:page="pageChange"
                             class="text-caption"
                             fixed-header>
            <template v-slot:[`item.name`]="{ item }">
                <product-link :product="item"></product-link>
            </template>
            <template v-slot:[`item.pricingRate`]="{ item }">
                ${{ numberWithCommas(item.pricingRate, 2) }}
            </template>
            <template #bottom v-if="removePaging">
            </template>
        </v-data-table-server>
    </div>
</template>
<style scoped>
</style>
<script>
    import { numberWithCommas } from "../../mixins/numberMixins";
    import { mapActions, mapState } from "vuex";

    function initialState() {
        return {
            saving: false,
            loading: false,
            searchTerm: '',
            itemsPerPage: 10,
            totalItems: 0,
            tableItems: [],
            tableLoading: false,
            page: 1,
            sortBy: null,
            searchDebounceTimer: null
        };
    }

    export default {
        name: "ContactProductsPanel",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadDatatable();
        },
        props: {
            object: Object,
            entity: Object
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            reset: function () {
                // Clear any pending debounce timer
                if (this.searchDebounceTimer) {
                    clearTimeout(this.searchDebounceTimer);
                }
                Object.assign(this.$data, initialState());
            },
            loadDatatable() {
                this.tableLoading = true;
                let route = this.$constants.entities.Product.ROUTE + "contactproducts?page=" + this.page + "&itemsPerPage=" + this.itemsPerPage;
                if (this.entity.TYPE == "Contact") {
                    route += "&id=" + this.object.id;
                }
                if (this.sortBy && this.sortBy.length > 0) {
                    route += "&sortBy=" + this.sortBy[0].key + "&sortOrder=" + this.sortBy[0].order;
                }
                if (this.searchTerm && this.searchTerm.length > 0) {
                    route += '&searchTerm=' + this.searchTerm;
                }
                this.$api.get(route)
                    .then(res => {
                        this.tableLoading = false;
                        this.tableItems = res.data.items;
                        this.totalItems = res.data.totalItems;
                    })
                    .catch(error => {
                        this.tableLoading = false;
                        this.showErrorSnack('There was an error loading the table data.');
                    });
            },
            debouncedSearch() {
                // Clear any existing timer
                if (this.searchDebounceTimer) {
                    clearTimeout(this.searchDebounceTimer);
                }

                // Set a new timer
                this.searchDebounceTimer = setTimeout(() => {
                    this.page = 1; // Reset to first page when searching
                    this.loadDatatable();
                }, 500); // 500ms delay - adjust as needed
            },
            itemsPerPageChange(itemsPerPage) {
                this.itemsPerPage = itemsPerPage;
                this.loadDatatable();
            },
            pageChange(page) {
                this.page = page;
                this.loadDatatable();
            },
            numberWithCommas
        },
        computed: {
            ...mapState({
            }),
            removePaging() {
                return (this.totalItems && this.totalItems <= this.itemsPerPage);
            },
            tableHeaders() {
                return [
                    { title: 'Code', key: 'code', width: "20%" },
                    { title: 'Name', key: 'name', width: "20%" },
                    { title: 'UOM', key: 'uomType', width: "20%" },
                    { title: 'Rate', key: 'pricingRate', width: "20%" }
                ];
            }
        },
        watch: {
            searchTerm: {
                handler() {
                    this.debouncedSearch();
                }
            }
        },
        beforeUnmount() {
            // Clean up timer when component is destroyed
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }
        }
    };
</script>